/* O-liminator theme JS — common behaviour ported from the approved source (AOS, header, mobile nav, smooth scroll, lazy fade). */
(function () {
  // ── AOS Visibility Contract ─────────────────────────────────
  if (window.AOS) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) document.documentElement.classList.add('js-aos-ready');
    AOS.init({ duration: 680, once: true, offset: 70, easing: 'ease-out-cubic', disable: reduce });
  }

  // ── Header scroll behavior ───────────────────────────────────
  var header = document.getElementById('site-header');
  function updateHeader() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  // ── Mobile nav ───────────────────────────────────────────────
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');
  if (hamburger && mobileNav && mobileClose) {
    var openMenu = function () {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      mobileClose.focus();
    };
    var closeMenu = function () {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    };
    hamburger.addEventListener('click', openMenu);
    mobileClose.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMenu();
    });
    document.addEventListener('click', function (e) {
      if (mobileNav.classList.contains('is-open') && !mobileNav.contains(e.target) && !hamburger.contains(e.target)) closeMenu();
    });
  }

  // ── Smooth scroll for anchor links ───────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href.length > 1) {
        var target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  // ── Lazy image fade-in ───────────────────────────────────────
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.style.transition = 'opacity 0.4s ease';
    if (img.complete) {
      img.style.opacity = '1';
    } else {
      img.style.opacity = '0';
      img.addEventListener('load', function () { img.style.opacity = '1'; });
      img.addEventListener('error', function () { img.style.opacity = '1'; }); // fail safe
    }
  });

  // ── "Choose Your Pack" — swap the product photo when a different scent is picked ──
  document.querySelectorAll('select[data-img-target]').forEach(function (select) {
    var img = document.getElementById(select.getAttribute('data-img-target'));
    var fallback = select.getAttribute('data-img-default');
    if (!img) return;
    function sync() {
      var opt = select.options[select.selectedIndex];
      var src = (opt && opt.getAttribute('data-img')) || fallback;
      if (src && img.src.indexOf(src) === -1) img.src = src;
    }
    select.addEventListener('change', sync);
    sync();
  });
})();
